module.exports = __webpack_public_path__ + "img/antonio.c1cc572d.webp";